import { i as e } from "./indexed-object.js";
import { r } from "./require-object-coercible.js";
var o = function o(_o) {
  return e(r(_o));
};
export { o as t };